import Link from 'next/link';
import React, { FC } from 'react';

import { Button } from '@mantine/core';

import { DCIDEController } from 'components/logo/DCIDEController';

import { MarketingHelpers } from 'helpers/MarketingHelpers';

import { Banner } from './Banner';

const Controller: FC = () => (
    <Banner
        logo={<DCIDEController height={42} />}
        title="Discover DCIDE Controller, the multivendor DC microgrid controller."
        description="DCIDE Controller accelerates your time to power with plug-and-play automation, optimizing DC flows from day one to deliver immediate savings and sustainability."
        actions={
            <Button component={Link} href={MarketingHelpers.urls.controller.overview()}>
                Learn more
            </Button>
        }
    />
);

export { Controller };
